import { PlotReportFactElement, PlotReportFactLabelFilter } from './fact';
import { OrganizationProduct } from './organization';

export type PlotReport = {
  plot_id: string;
  facts: PlotReportFactElement[];
};

export type FactsByFactType = Record<string, PlotReportFactElement>;

/**
 * GET /api/v1/dashboard/plot-report/{plot_id}
 */
export const GET_DASHBOARD_PLOT_REPORT_PATH = 'dashboard/plot-report/{plot_id}';
export type GetDashboardPlotReportRequestPathVariables = { plot_id: string };

export type GetDashboardPlotReportRequestQueryParams =
  | (PlotReportFactLabelFilter & {
      plot_group_id?: string;
      fact_names?: string;
      source_ref?: string;
      date_filters?: { start_date_inclusive?: string; end_date_inclusive?: string };
    })
  | undefined;
export type GetDashboardPlotReportSuccessDto = PlotReport;

export type GetDashboardPlotReportErrorDto = Error;

/**
 * GET /api/v1/dashboard/buyer/plot-report/{plot_id}/
 */
export const GET_BUYER_DASHBOARD_PLOT_REPORT_PATH = 'dashboard/buyer/plot-report/{plot_id}/';
export type GetBuyerDashboardPlotReportRequestPathVariables = {
  plot_id: string;
  start_date_inclusive?: string;
  end_date_inclusive?: string;
};

export type GetBuyerDashboardPlotReportRequestQueryParams =
  | (PlotReportFactLabelFilter & { source_ref?: string })
  | undefined;
export type GetBuyerDashboardPlotReportSuccessDto = PlotReport;

export type GetBuyerDashboardPlotReportErrorDto = Error;

/**
 * GET /api/v1/dashboard/organization-product/
 */
export const GET_DASHBOARD_ORGANIZATION_PRODUCT_PATH = 'dashboard/organization-product';
export type GetDashboardOrganizationProductRequestPathVariables = undefined;
export type GetDashboardOrganizationProductRequestQueryParams = {
  organization_id: string;
  purchased?: boolean;
};
export type GetDashboardOrganizationProductSuccessDto = OrganizationProduct[];
export type GetDashboardOrganizationProductErrorDto = Error;
